/**
 * Set up routing for all Study views
 *
 * For an example with protected routes, refer to /product/ProductRouter.js.jsx
 */

// import primary libraries
import React from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';

// import global components
import AdminLayout from '../admin/components/AdminLayout.js.jsx';
import Base from "../../global/components/BaseComponent.js.jsx";
import YTRoute from '../../global/components/routing/YTRoute.js.jsx';

// import course views
import AdminCreateCourseFromStudy from '../course/views/AdminCreateCourseFromStudy.js.jsx';
import AdminSingleCourse from '../course/views/AdminSingleCourse.js.jsx';
import AdminUpdateCourse from '../course/views/AdminUpdateCourse.js.jsx';

// import site views
import AdminCreateSiteFromStudy from '../site/views/AdminCreateSiteFromStudy.js.jsx';
import AdminUpdateSiteFromStudy from '../site/views/AdminUpdateSiteFromStudy.js.jsx';
import AdminStudySiteList from '../site/views/AdminStudySiteList.js.jsx';
import AdminSingleSite from '../site/views/AdminSingleSite.js.jsx';
import AdminUpdateSite from '../site/views/AdminUpdateSite.js.jsx';

// import study views
import AdminStudyList from './views/AdminStudyList.js.jsx';
import AdminStudyTrainingManagement from './views/AdminStudyTrainingManagement.js.jsx'; // replacement page for AdminSingleStudy

// import study user views
import AdminSingleStudyUser from '../studyUser/views/AdminSingleStudyUser.js.jsx';
import AdminUpdateStudyUser from '../studyUser/views/AdminUpdateStudyUser.js.jsx';
import AdminSingleModuleCertificateRedirect from '../moduleCertificate/views/AdminSingleModuleCertificateRedirect.js.jsx';
import AdminStudyRolesMatrix from '../studyRole/views/AdminStudyRolesMatrix.js.jsx';
import LinkSiteLocation from '../site/views/LinkSiteLocation.js.jsx';
import AdminSingleGroupUserCertificateList from '../studyUser/views/AdminSingleGroupUserCertificateList.js.jsx';

class StudyAdminRouter extends Base {
  constructor(props) {
    super(props);
  }

  render() {
    let singleStudyCoursesPath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/courses'), 0);
    let singleStudyCourseDetailsPath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/update-course'), 0);
    let singleStudySitesPath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/sites'), 0);
    let singleStudySiteDetailsPathFromLocation = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/link-location'), 0);
    let singleStudySiteDetailsPathFromUpdate = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/update-site'), 0);
    let singleStudySUPath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/study-users'), 0);
    let singleStudyUserCertPath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/cert'), 0);
    let singleStudyRolesPath = this.props.location.pathname.substring(this.props.location.pathname.indexOf('/roles'), 0);


    return (
      <Switch>
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: null}]}
          component={AdminStudyList}
          exact
          path="/admin/content-management/studies"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: null}]}
          component={AdminStudyTrainingManagement}
          exact
          path="/admin/content-management/studies/:studyId"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: singleStudySitesPath}, {display: 'Sites', path: null}]}
          component={AdminStudySiteList}
          exact
          path="/admin/content-management/studies/:studyId/sites"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: singleStudySitesPath}, {display: 'Sites', path: `${singleStudySitesPath}/sites`}, {display:'New site', path: null}]}
          component={AdminCreateSiteFromStudy}
          exact
          path="/admin/content-management/studies/:studyId/sites/new"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: singleStudySitesPath}, {display: 'Sites', path: `${singleStudySitesPath}/sites`}, {display:'Site details', path: null}]}
          component={AdminSingleSite}
          exact
          path="/admin/content-management/studies/:studyId/sites/:siteId"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: singleStudySitesPath}, {display: 'Sites', path: `${singleStudySitesPath}/sites`}, {display:'Site details', path: singleStudySiteDetailsPathFromLocation}, {display: 'Link location', path:null}]}
          component={LinkSiteLocation}
          exact
          path="/admin/content-management/studies/:studyId/sites/:siteId/link-location"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: singleStudySitesPath}, {display: 'Sites', path: `${singleStudySitesPath}/sites`}, {display:'Site details', path: singleStudySiteDetailsPathFromUpdate}, {display: 'Update', path:null}]}
          component={AdminUpdateSiteFromStudy}
          exact
          path="/admin/content-management/studies/:studyId/sites/:siteId/update-site"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: singleStudySUPath}, {display: 'Program Permissions', path: `${singleStudySUPath}/study-users`}, {display: 'User details', path: singleStudyUserCertPath}, {display: 'Module certificate', path: null}]}
          component={AdminSingleModuleCertificateRedirect}
          exact
          path="/admin/content-management/studies/:studyId/study-users/:studyUserId/certs/:moduleCertificateId"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: singleStudyCoursesPath},  {display: 'Add new course', path: null}]}
          component={AdminCreateCourseFromStudy}
          exact
          path="/admin/content-management/studies/:studyId/courses/new"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: singleStudyCoursesPath},  {display: 'Course details', path: null}]}
          component={AdminSingleCourse}
          exact
          path="/admin/content-management/studies/:studyId/courses/:courseId"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: singleStudyCoursesPath},  {display: 'Course details', path: singleStudyCourseDetailsPath}, {display: 'Update', path: null}]}
          component={AdminUpdateCourse}
          exact
          path="/admin/content-management/studies/:studyId/courses/:courseId/update-course"
          role="admin"
        />
        <YTRoute
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: singleStudyRolesPath}, {display: 'Training Roles', path: null}]}
          component={AdminStudyRolesMatrix}
          exact
          path="/admin/content-management/studies/:studyId/roles"
          role="admin"
        />
        <YTRoute // we need to change breadcrumbs to link back to rome
          breadcrumbs={[{display: 'All Programs', path: '/admin/content-management/studies'}, {display: 'Program Training Details', path: singleStudySUPath}, {display: 'Program Permissions', path: `${singleStudySUPath}/study-users`}, {display: 'User details', path: singleStudyUserCertPath}, {display: 'Module certificate', path: null}]}
          component={AdminSingleGroupUserCertificateList}
          exact
          path="/admin/content-management/studies/:studyId/study-users/:studyUserId/certs" 
          role="admin"
        />
      </Switch>
    )
  }
}

export default withRouter(StudyAdminRouter);



// WEBPACK FOOTER //
// modules/study/StudyAdminRouter.js.jsx